<template>
    <el-radio-group v-model="name" size="mini">
        <el-radio-button :label="item.name" v-for="item in list" :key="item.name">{{item.name}}</el-radio-button>
    </el-radio-group>
</template>

<script>
  import {REFERRAL_STATUS,REFERRAL_STATUS_INIT,REFERRAL_STATUS_DOC} from "../../lib/config";

  export default {
    name: "referral-tabs",
    props: {
      value: {
        type: Array,
        default() {
          return ['2'];
        }
      },
    },
    data() {
      return {
        name: '申请中',
        list: REFERRAL_STATUS_INIT
      }
    },
    watch: {
        name(newV) {
             this.$emit('input', this.list.find(r => r.name === newV)['id']);
        },
        $route(){
            this.getTabArr();
        }
    },
      methods:{
        getTabArr(){
            //原型上文案区别
            const {type} = this.$route.meta;
            if(type == 'init'){
                this.name = '申请中';
                this.list = REFERRAL_STATUS_INIT;
            }else{
                if(this.loginInfo.doc.docType == "DOC"){
                    this.name = '已完成';
                    this.list = REFERRAL_STATUS_DOC;
                }else{
                    this.name = '待处理';
                    this.list = REFERRAL_STATUS;
                }
            }
        }
      },
      created() {
          this.getTabArr();
      }
  }
</script>

<style scoped>

</style>
